/*
 *   File : add-location.js
 *   Author : https://evoqins.com
 *   Description : Add admin modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';

//Custom component
import { CustomTextInput } from '../FormElements';
import { PrimaryButton } from '../Buttons';
import { Icon } from '../Icon';
import { APIService } from '../../Service';
import { toast } from 'react-toastify';

const AddLocationModal = React.memo((props) => {
    const [locationUrl, setLocationUrl] = useState("");
    const [locationUrlError, setLocationUrlError] = useState("");

    const [loader, setLoader] = useState(false);

    useEffect(() => {
        if (props.locationUrl !== null && props.locationUrl) {
            setLocationUrl(props.locationUrl);
        } else {
            setLocationUrl("");
        }
    }, [props.locationUrl]);


    useEffect(() => {
        var my_modal = document.getElementById("add-location-modal");
        my_modal.addEventListener("hidden.bs.modal", () => {

            setLocationUrl("");
        });
    }, []);

    useEffect(() => {
        setLocationUrlError("");
    }, [locationUrl]);


    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("add-location-modal-close");
        button.click();
        props.handleClose();
    }

    // handle add admin submit
    const _handleSubmit = () => {
        let is_valid = true;

        if (locationUrl.trim().length === 0) {
            setLocationUrlError("Location URL is required");
            is_valid = false;
        }

        if (is_valid === true) {
            setLoader(true);
            _addLocationUrl();
        }
    }

    //API - Add location URL
    const _addLocationUrl = () => {
        let is_post = true;
        let url = 'CA/store/add-location-url';
        let data = {
            "store_id": props.id,
            "location_url": locationUrl
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success(props.locationUrl ? "Successfully updated location URL" : "Successfully added location URL", {
                    type: "success",
                    className: "e-toast",
                });
                _handleCloseModal();

                props.handleSuccess();
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setLoader(false);
        });
    };


    return (
        <div className="modal fade" id="add-location-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="addAdminLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered e-border-radius-12px modal-dialog-scrollable">
                <div className="modal-content e-border-radius-12px w- margin-auto p-4">
                    <button id='add-location-modal-close' type="button" className="btn-close d-none shadow-none" data-bs-dismiss="modal" aria-label="Close" ></button>

                    <div className="modal-header px-0 pt-0 pb-2 border-0 align-items-start flex-column">
                        <div className='d-flex justify-content-between w-100 mb-2'>
                            <h4 className="mb-0 e-text-dark-jungle-green e-primary-font-playfair e-font-18 e-font-weight-500 line-height-28px">
                                {props.locationUrl ? "Edit store location" : "Add store location"}
                            </h4>

                            <Icon icon="close-icon"
                                className='cursor-pointer'
                                size="24px"
                                onPress={_handleCloseModal} />
                        </div>

                        <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                            Paste the Google Maps share link for this store.
                        </p>
                    </div>
                    <div className="modal-body px-0 pt-2 pb-2">
                        <CustomTextInput label={props.locationUrl ? "Edit link" : "Add link"}
                            placeholder={props.locationUrl ? "Edit location link" : "Add location link"}
                            type="text"
                            require
                            value={locationUrl}
                            error={locationUrlError}
                            className="w-100"
                            labelStyle="e-font-weight-500 e-text-raisin-black"
                            onKeyPress={_handleSubmit}
                            handleChange={(e) => setLocationUrl(e)} />


                    </div>

                    <div className='modal-footer border-0 pt-1 px-0 pb-0'>
                        <div className='row w-100 gx-3 m-0'>
                            <div className='col-6 ps-0'>
                                <PrimaryButton name="Cancel"
                                    className="e-bg-transparent e-border-1px-spanish-gray e-text-raisin-black w-100 e-border-radius-16px"
                                    onPress={_handleCloseModal} />
                            </div>
                            <div className='col-6 pe-0'>
                                <PrimaryButton name={props.locationUrl ? "Update" : "Add"}
                                    className="w-100 e-border-radius-16px"
                                    status={loader}
                                    onPress={_handleSubmit} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
});


AddLocationModal.defaultProps = {
    closeModal: () => { }
}

export default memo(AddLocationModal);